import React from "react";
import { Button, Modal } from 'semantic-ui-react'
import * as PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  //Button,
  Typography,
  makeStyles,
  Slide
} from "@material-ui/core";
import clsx from "clsx";
import red from "@material-ui/core/colors/red";

const useStyles = makeStyles(() => ({
  dialog: {
    borderRadius: 0
  },
  fontSize:{
    fontSize:"14px !important"
  },
  fontColor:{
    color:"red",
    fontWeight:"bold !important",
    fontSize:"14px !important"
  },
  button: {
    borderRadius: 0,
    textTransform: "none",
    padding: 5
  },
  logout: {
    color: "#fff",
    backgroundColor: red[500],
    "&:hover": {
      backgroundColor: red[700]
    }
  },
  countdown: {
    color: red[700]
  }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function SessionTimeoutDialog({
  open,
  countdown,
  onLogout,
  onContinue
}) {
  const classes = useStyles();
  let minutes = Math.floor(countdown / 60);
  let seconds = countdown - minutes * 60;
  return (
    /*<Dialog
      open={open}
      aria-labelledby="session-timeout-dialog"
      aria-describedby="session-timeout-dialog"
      classes={{ paper: classes.dialog }}
      TransitionComponent={Transition}
    >
      <DialogTitle id="session-timeout-dialog-title">
        Session Timeout
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          The current session is about to expire in{" "}
          <span className={classes.countdown}>{minutes}</span> Minutes<span className={classes.countdown}> {seconds}</span> Seconds.
        </Typography>
        <Typography variant="body2">{`Would you like to continue the session?`}</Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onLogout}
          variant="contained"
          className={clsx(classes.logout, classes.button)}
        >
          Logout
        </Button>
        <Button
          onClick={onContinue}
          color="primary"
          variant="contained"
          className={classes.button}
        >
          Continue Session
        </Button>
      </DialogActions>
    </Dialog>*/
    <Modal
      open={open}
      size="tiny"
      dimmer={"blurring"}>
      <Modal.Header><h2 style={{color:"white"}}>Session Timeout</h2></Modal.Header>
      <Modal.Content className={classes.fontSize}>
        The current session is about to expire in{" "}
        <span className={classes.fontColor}>{minutes}</span> Minutes<span className={classes.fontColor}> {seconds}</span> Seconds.
        </Modal.Content>
      <Modal.Actions>
        <Button negative onClick={onLogout}>
          Logout
          </Button>
        <Button  onClick={onContinue}
          color="primary">
          Continue
          </Button>
      </Modal.Actions>
    </Modal>

  );
}

SessionTimeoutDialog.propTypes = {
  /**
   * indicator whether the dialog is open/close
   */
  open: PropTypes.bool.isRequired,
  /**
   * the countdown timer.
   */
  countdown: PropTypes.number.isRequired,
  /**
   * callback function to handle closing action
   */
  onLogout: PropTypes.func.isRequired,
  /**
   * callback function to handle confirm action.
   */
  onContinue: PropTypes.func.isRequired
};
